export default __webpack_public_path__ + "static/media/Girls-Hostel.c90f5716.jpg";